export class VehicleNameFormatter {
  static removeYearFromModelName(
    vehicleName: string | null | undefined,
    isAudiMake: boolean,
  ): string | undefined {
    if (!vehicleName) return undefined;
    return isAudiMake ? vehicleName.toString().slice(5) : vehicleName;
  }

  static isAudiMake(vehicle?: any): boolean {
    return vehicle?.titleText?.includes('Audi') ?? false;
  }
}
